import React from 'react';
import {  Container, Row, Col} from 'reactstrap';
//import {Link} from 'react-router';
import urlBase from '../../url-base';
import CookieConsent from 'react-cookie-consent-notification';

const checkStatus = (status) => {
  if(status) {
    // To set a cookies
  }
};

class Footer extends React.Component {

  
  constructor(props) {
    super(props);

    this.state = {
      
    };

    this.styles = {
      
    };
  }

  
  toLink(){
    location.href = urlBase.client + "privacypolicy";
  }

  

  render() {

    return (
      <div id="footer_new">
          <div id="footer_app">
            <Row style={{marginRight: 0}}>
              <Col className="payment_slip_app_col" style={{marginTop:60}} xs="12" sm="12" md="1" lg="1" xl="1">{''}</Col>
              <Col style={{marginTop:30}} xs="12" sm="12" md="5" lg="5" xl="5">
                <div className="p_app_1">
                  Tudo que você precisa pra
                </div>
                <div className="p_app_2" >
                  usar o plano tá no APP!
                </div>
                 <Row>
                     <Col md="1"  >
                          <div className="footer_img_check">  </div>     
                     </Col>                     
                     <Col md="5" >
                         <p className="p_app_text">
                          Carteirinha
                         </p>
                      </Col>               
                      <Col md="1" >
                          <div className="footer_img_check">  </div>     
                       </Col>                              
                      <Col md="5">                      
                         <p className="p_app_text">
                          Avalidação de atendimento
                         </p>
                      </Col>
                 </Row>
                 <Row>
                        <Col md="1">
                          <div className="footer_img_check"> </div>     
                       </Col>                  
                      <Col md="5">
                         <div className="p_app_text" >
                          Buscar por dentistas
                         </div>
                      </Col>
                      <Col md="1">
                          <div className="footer_img_check">  </div>     
                       </Col>                         
                      <Col md="5">
                         <p className="p_app_text">
                          Informações financeiras
                         </p>
                      </Col>
                 </Row>
                 <Row>
                       <Col md="1">
                          <div  className="footer_img_check">  </div>     
                       </Col>
                       <Col md="5">
                          <p className="p_app_text">
                            2ª via de boleto
                          </p>
                       </Col>
                       <Col md="1">
                          <div className="footer_img_check">  </div>     
                       </Col>                          
                      <Col md="5">
                         <p className="p_app_text">
                          Chat com a Aidê
                         </p>
                      </Col>
                 </Row> 
                 <br/>
                                 
                <div id="payment_slip_app_img" style={{marginTop: 15}}>
                  <a href="https://play.google.com/store/apps/details?id=br.com.planodentalcenter" target="_blank">
                    <img src={urlBase.client+'assets/images2/new_layout/footer_app_google_play.svg'} width="187" height="56" />
                  </a>
                  <a href="https://itunes.apple.com/br/app/dentalcenter-associado/id1281072501?mt=8" target="_blank">
                    <img src={urlBase.client+'assets/images2/new_layout/footer_app_store.svg'} width="187" height="56" />
                  </a>
                </div>
              </Col>
              <Col className="payment_slip_app_col" style={{marginTop:30}} xs="12" sm="12" md="1" lg="1" xl="1">{''}</Col>
              <Col id="my_dental_col"  xs="12" sm="12" md="4" lg="4" xl="4">
                  <div className="footer_img_detalhe_celular">  </div>                     
                  <div className="footer_img_fone">  </div>                     
                  <div className="footer_img_celular">  </div>                     
              </Col>
              <Col style={{marginTop:30}} xs="12" sm="12" md="1" lg="1" xl="1">{''}</Col>
            </Row>
            
          </div>     
         
        <div className="line_footer_vertical2">{""}</div>

        <Container className="container_footer" style={{padding:0, marginTop:50}}>

          <Row>
            <Col sm="1" >
                {/* Imagens 2 */}
                <div className="footer_img_logo_dental">  </div>  
            </Col>
            
            <Col md="3" >
              <p className="text_footer">Nossos serviços</p>
              <div className="footer_sub_linha_texto">{""}</div>
              <div className="div_text_footer">
                <p className="text_footer2">Plano empresarial</p>
                <p className="text_footer2">Planos individuais e familiares</p>
                <p className="text_footer2">Encontre um dentista</p>
              </div>
            </Col>  
            <Col md="0">
            <div className="line_footer_vertical">{""}</div>
            </Col>          
            <Col md="3" >
              <p className="text_footer">Sobre a dental center</p>
              <div className="footer_sub_linha_texto">{""}</div>
              <div >
              <p className="text_footer2">Quem somos</p>
                <p className="text_footer2">Política de Segurança e Privacidade</p>
                <br/>

                <p className="text_footer3">Pagamentos aceitos:</p>
              </div>
              <div className="footer_sub_linha_texto">{""}</div>
              <img src={urlBase.client+'assets/images2/new_layout/footer_pag_aceitos.svg'} width="220px" height="20px"/>&emsp;

            </Col>
            <Col md="0">
               <div className="line_footer_vertical">{""}</div>
            </Col>  
            <Col md="4" >
              <p className="text_footer">Contato</p>
              <div className="footer_sub_linha_texto">{""}</div>
              <div className="div_text_footer">
              <p className="text_footer2">
                         <img src={urlBase.client+'assets/images2/new_layout/footer_fone_vermelho.svg'} width="24px" height="24px"/>&emsp; 
                          Paraíba: (83) 3041.4646
                         </p>                
                         <p className="text_footer2">
                         <img src={urlBase.client+'assets/images2/new_layout/footer_fone_vermelho.svg'} width="24px" height="24px"/>&emsp;
                          Demais estados: 4004-8790
                         </p> 
                         <br/><br/>

                         <p className="text_footer3">Endereço:</p>
                         <div className="footer_sub_linha_texto">{""}</div>

              </div>
              <p className="text_footer2">
                         <img src={urlBase.client+'assets/images2/new_layout/footer_localizacao.svg'} width="24px" height="24px"/>&emsp;
                          Matriz     
              </p>   
              <p className="text_footer2_margin" >
                          Rua Desembargador<br/>
                          José Peregrino 216, <br/>
                          Centro João Pessoa - Paraíba<br/>
                          CEP: 58013-500              
              </p>            
            </Col>            
          </Row>
          <br/><br/>

          <Row>
            <Col >
                <div className="div_1_ans">
                    <div className="div_2_ans">
                          <div className='text_ans'>33945-8</div>
                    </div>
                    <div className="copyright">© 2023 Dental Center. Todos os direitos reservados</div>               
                </div>
            </Col>
          </Row>

        </Container>


               
    <CookieConsent 
      background={'#D10B24'}
      bottomPosition={true}
      buttonText={'EU CONCORDO'}
      buttonBackground={'#fff'}
      buttonHei
      buttonColor={'#000'}
      buttonFontSize={16}
      color={'#fff'}
      consentFunction={checkStatus}
      padding={20}
    >
      Não utilizamos cookies e outras tecnologias semelhantes. <a href={'https://planodentalcenter.com.br/assets/docs/privacidade-de-dados.docx.pdf'} target='_blanc' style={{ color: '#ffeb3b' }}> Clique aqui para ler nossa Política de privacidade </a>
    </CookieConsent>
  

      </div>
    );

  }

}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/Footer.js
 **/